var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.18.1@lodash/_Uint8Array.js
// module id = 1510
// module chunks = 0